<template>
  <div class="pc_header">
    <div :class="['circle', { expand: state.open }]"></div>
    <div class="pc_header_content clear">
      <a href="/#/home" class="header_content_logo fl">
        <img draggable="false" :src="data.companyIconUrl" />
      </a>
      <div class="header_content_right clear fr">
        <div :class="['menu fl clear', { on: state.open }]">
          <ul>
            <li
              :class="['fl', { on: routeInfo.name === 'home' }, { animate: state.open }]"
            >
              <a
                @click="handleServeRoute('home')"
                href="/#/home"
                class="menu_title"
                :style="{
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                }"
                >首页</a
              >
            </li>
            <li
              :class="['fl', { on: routeInfo.name === 'about' }, { animate: state.open }]"
            >
              <a
                @click="handleServeRoute('about')"
                href="/#/about"
                class="menu_title"
                :style="{
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                }"
                >关于我们</a
              >
            </li>
            <li
              :class="[
                'fl',
                {
                  on:
                    routeInfo.name === 'service' ||
                    routeInfo.name === 'internetThings' ||
                    routeInfo.name === 'remoteSensing' ||
                    routeInfo.name === 'project',
                },
                { animate: state.open },
              ]"
            >
              <a
                href="javascript:;"
                class="menu_title service_items"
                @click="handleToggleService"
                :style="{
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                }"
                >服务项目</a
              >
              <div
                :class="[
                  'DropDown clear',
                  {
                    on: state.isMobile
                      ? state.isFixed && state.serveState
                      : state.isFixed && isSpecialRoute(routeInfo.name),
                    in: state.isMobile ? false : !state.isFixed && state.serveState,
                  },
                ]"
              >
                <!-- {
                    on:
                      state.serveState === true ||
                      isSpecialRoute(routeInfo.name),
                    in: state.serveState === false,
                },-->
                <div class="DropDown_content">
                  <a
                    @click="handleServeRoute('service')"
                    href="/#/service"
                    :class="['fl', { on: routeInfo.name === 'service' }]"
                  >
                    <!-- <dd class="projectIconfont">&#xe653;</dd> -->
                    <dd class="projectIconfont">
                      <i class="iconfont icon-fangan" style="font-size: 28px"></i>
                    </dd>
                    <dt>一站式服务</dt>
                  </a>
                  <a
                    @click="handleServeRoute('internetThings')"
                    href="/#/internetThings"
                    :class="['fl', { on: routeInfo.name === 'internetThings' }]"
                  >
                    <!-- <dd class="projectIconfont">&#xe660;</dd> -->
                    <dd class="projectIconfont">
                      <i
                        class="iconfont icon-a-genggaosugengwendingdeduxiangzhuanxiandaikuan"
                        style="font-size: 28px"
                      ></i>
                    </dd>
                    <dt>物联网接入</dt>
                  </a>

                  <a
                    @click="handleServeRoute('remoteSensing')"
                    href="/#/remoteSensing"
                    :class="['fl', { on: routeInfo.name === 'remoteSensing' }]"
                  >
                    <!-- <dd class="projectIconfont">&#xedaa;</dd> -->
                    <dd class="projectIconfont">
                      <i class="iconfont icon-yaoganfuwu" style="font-size: 28px"></i>
                    </dd>
                    <dt>遥感服务</dt>
                  </a>

                  <a
                    @click="handleServeRoute('project')"
                    href="/#/project"
                    :class="['fl', { on: routeInfo.name === 'project' }]"
                  >
                    <!-- <dd class="projectIconfont">&#xe60a;</dd> -->
                    <dd class="projectIconfont">
                      <i class="iconfont icon-xiangmuguanli" style="font-size: 28px"></i>
                    </dd>
                    <dt>项目管理</dt>
                  </a>
                </div>
                <div
                  v-if="state.isMobile && state.serveState"
                  @click="handleCloseService"
                  class="DropDown_close iconfont"
                >
                  <i class="iconfont icon-chacha"></i>
                </div>
              </div>
            </li>
            <li
              :class="['fl', { on: routeInfo.name === 'case' }, { animate: state.open }]"
            >
              <a
                @click="handleServeRoute('case')"
                href="/#/case"
                class="menu_title"
                :style="{
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                }"
                >案例展示</a
              >
            </li>
            <li
              :class="[
                'fl',
                { on: routeInfo.name === 'contact' },
                { animate: state.open },
              ]"
            >
              <a
                @click="handleServeRoute('contact')"
                href="/#/contact"
                class="menu_title"
                :style="{
                  display: state.isMobile && (state.serveState ? 'none' : 'block'),
                }"
                >联系我们</a
              >
            </li>
          </ul>
        </div>
        <div class="header_content_phone fr">
          <!-- <span class="iconfont">&#xe6ee;</span> -->
          <span class="iconfont"> <i class="iconfont icon-dadianhua"></i></span>

          {{ data.companyTel }}
        </div>
      </div>
      <div :class="['burger fr', { open: state.open }]" @click="handleToggle">
        <div :class="['x ', { 'collapse rotate30 rotate45': state.open }]"></div>
        <div
          :class="['y ', { collapse: state.open }]"
          :style="{ display: state.open ? 'none' : 'block' }"
        ></div>
        <div :class="['z ', { 'collapse rotate150 rotate135': state.open }]"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  ref,
  reactive,
  watch,
  defineProps,
  onMounted,
  onBeforeUnmount,
  watchEffect,
} from "vue";
// 导入Vue Router的useRoute钩子
import { useRoute } from "vue-router";
import { getPortalBaseInfo } from "@/api/contact";

// 获取当前路由对象
const route = useRoute();
const routeInfo = reactive({
  name: route.name,
});
const state = reactive({
  open: false,
  serveState: false,
  isMobile: false,
  isFixed: false,
});

// 基础信息
const data = reactive({});

// 获取基础信息
getPortalBaseInfo({ t: Date.now() }).then((res: any) => {
  if (res.code === 200) {
    Object.assign(data, res.data);
  }
});

const isSpecialRoute = (name: string) => {
  return ["service", "internetThings", "remoteSensing", "project"].includes(name);
};
const handleToggle = () => {
  state.open = !state.open;
};
const handleToggleService = () => {
  if (state.isMobile) {
    state.isFixed = true;
  } else {
    return;
  }
  state.serveState = !state.serveState;
};
const handleCloseService = () => {
  state.open = true;
  state.serveState = false;
  if (state.isMobile) {
    state.isFixed = false;
  }
};

const handleServeRoute = (name) => {
  state.open = false;
  state.serveState = false;
  if (isSpecialRoute(name)) {
    state.isFixed = true;
  }
};

// 定义处理视窗大小变化的函数
const handleWindowResize = () => {
  state.isMobile = window.innerWidth > 1065 ? false : true;
  console.log("state.isMobile:", state.isMobile);
};
onMounted(() => {
  state.isMobile = window.innerWidth > 1065 ? false : true;
  console.log("state.isMobile:***********************", state.isMobile);
  window.addEventListener("resize", handleWindowResize);
  // 直接监听route.name变化，无须指定getter和setter
  watchEffect(() => {
    // let routerList = [
    //   "home",
    //   "about",
    //   "service",
    //   "internetThings",
    //   "remoteSensing",
    //   "project",
    //   "case",
    //   "contact",
    // ];
    routeInfo.name = route.name;

    let saveState = ["service", "internetThings", "remoteSensing", "project"].includes(
      route.name
    );
    if (saveState && state.isMobile == false) {
      state.open = true;
      // state.serveState = false;
      state.isFixed = true;
    }
  });
});
// 在组件卸载时移除 resize 事件监听器，避免内存泄漏
onBeforeUnmount(() => {
  window.removeEventListener("resize", handleWindowResize);
});
</script>
<style lang="scss" scoped></style>
